// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: 620,
    zIndex: 10,
    [theme.breakpoints.down(750)]: {
      margin: 5,
      width: '95%',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '0 !important',
    zIndex: 15,
  },
  buttonStyleSubmit: {
    width: 200,
    margin: '15px auto',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(750)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  rowContainerFlexEnd: {
    alignItems: 'flex-end !important',
    [theme.breakpoints.down(750)]: {
      alignItems: 'center !important',
    },
  },
  inputMargin: {
    marginRight: 10,
    marginLeft: 10,
  },
  passwordHelper: {
    width: 290,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  buttonStyle: {
    width: 120,
    marginBottom: '0 !important',
  },
  buttonContainer: {
    width: 300,
    height: '100%',
    alignItems: 'flex-end',
    display: 'flex',
    [theme.breakpoints.down(750)]: {
      width: 'fit-content',
    },
  },
  registerDisclaimer: {
    maxWidth: '100%',
    margin: '5px 0',
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  paddingLeft: {
    paddingLeft: '1.25rem',
  },
  blueColor: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    '&:hover': {
      color: GlobalStyles.color.COLOR_SECONDARY,
      textDecoration: 'none',
    }
  },
  topTextStyle: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  topText1: {
    margin: '10px 0',
  },
  topText2: {
    marginBottom: 10,
  },
  error: {
    margin: 5,
    color: 'red',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  checkbox: {
    width: 15,
    height: 15,
    marginTop: 0,
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inputWithBottomHelper: {
    display: 'flex',
    flexDirection: 'column',
  },
  rowContainerWithBottomHelper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 10,
    [theme.breakpoints.down(750)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  searchInputStyle: {
    width: 290,
  }
});

export default styles;
